import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UpdateButton from "./UpdateButton";
import { updatePricing } from "../../../../services/vendor/vendor.service";

const ManageGlobalMargin = ({ selectedItem, isRender, setIsRender }) => {
  const [loading, setLoading] = useState(false);
  console.log(selectedItem);

  const [formData, setFormData] = useState({
    mapPercentage: selectedItem?.mapPercentage,
    nonMapPercentage: selectedItem?.nonMapPercentage,
  });

  const handleUpdate = async (id) => {
    setLoading(true);
    try {
      const res = await updatePricing({
        id,
        isCustomPricing:false,
        ...formData,

      });
      if (res?.data?.message) {
        setLoading(false);
        setIsRender(!isRender);
      }
      console.log("Simulating update with data:", formData);
      setLoading(false);
      if (setIsRender) setIsRender(!isRender);
    } catch (error) {
      setLoading(false);
      console.error("Update failed:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: Number(e.target.value),
    });
  };

  const handleIncrement = (name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: (prev[name] || 0) + 1,
    }));
  };

  const handleDecrement = (name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: Math.max(0, (prev[name] || 0) - 1),
    }));
  };

  return (
    <Container fluid className="p-0">
      <Row className="d-flex justify-content-between align-items-center py-3 px-2 mx-0">
        <Col xs="auto">
          <Typography
            variant="h5"
            component="div"
            sx={{ fontWeight: "bold", fontSize: "16px" }}
          >
            {selectedItem?.fullName}
          </Typography>
        </Col>
        <Col xs="auto" className="d-flex justify-content-end">
          <Chip
            label="Using Default Margins"
            icon={<CheckCircleIcon />}
            sx={{
              backgroundColor: "#004a80",
              color: "white",
              borderRadius: "20px",
              fontWeight: "bold",
              height: "40px",
              fontSize: "1rem",
              "& .MuiChip-icon": {
                color: "white !important",
              },
            }}
          />
        </Col>
      </Row>

      {/* Blue Section Title: "Default Margins" */}
      <Row className="mx-0">
        <Col className="p-0 m-0">
          <div
            className="text-white text-center py-2"
            style={{ backgroundColor: "#004a80" }} // Custom blue background and rounded corners
          >
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: "bold", fontSize: "18px" }}
            >
              Default Margins
            </Typography>
          </div>
        </Col>
      </Row>

      {/* Margins Input Section: "Default Margins" label on left, Map and NonMap inputs on right */}
      <Row className="d-flex justify-content-center align-items-center ">
        {/* Responsive column sizing */}
        <div className="d-flex align-items-center w-100">
          <Row className="d-flex align-items-center">
            <Col
              xs={4}
              style={{
                borderLeft: "0.5px solid #e1e5e8",
                borderRight: "0.5px solid #e1e5e8",
                borderBottom: "0.5px solid #e1e5e8",
                padding: "0.5rem  0.2rem",
                height: "70px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "normal",
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Default Margins
              </Typography>
            </Col>
            <Col
              xs={3}
              style={{
                borderLeft: "0.5px solid #e1e5e8",
                borderRight: "0.5px solid #e1e5e8",
                borderBottom: "0.5px solid #e1e5e8",
                padding: "0.5rem  0.2rem",
                height: "70px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* Map Input Box */}
              <div className="input-wrapper">
                <label htmlFor="map" className="label">
                  Map
                </label>
                <input
                  type="number"
                  id="map"
                  name="map"
                  min="1"
                  value={formData?.mapPercentage}
                  onChange={handleChange}
                />
                <div
                  style={{
                    position: "absolute", // Position buttons absolutely
                    right: "8px", // Align to the right side of the main container
                    top: "50%", // Vertically center
                    transform: "translateY(-50%)", // Adjust for exact vertical centering
                    display: "flex",
                    flexDirection: "column", // Stack buttons vertically
                    gap: "3px",
                  }}
                >
                  <button
                    onClick={() => handleIncrement("mapPercentage")}
                    style={{
                      backgroundColor: "#e5e5e6",
                      borderRadius: "6px",
                      border: "none",
                      padding: "0",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#666",
                      outline: "none",
                      transition: "background-color 0.2s",
                    }}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </button>

                  <button
                    onClick={() => handleDecrement("mapPercentage")}
                    style={{
                      backgroundColor: "#e5e5e6",
                      borderRadius: "6px",
                      border: "none",
                      padding: "0",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#666",
                      outline: "none",
                      transition: "background-color 0.2s",
                    }}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </button>
                </div>
              </div>
            </Col>
            <Col
              xs={3}
              style={{
                borderLeft: "0.5px solid #e1e5e8",
                borderRight: "0.5px solid #e1e5e8",
                borderBottom: "0.5px solid #e1e5e8",
                padding: "0.5rem  0.2rem",
                height: "70px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* NonMap Input Box (structure identical to Map) */}
              <div className="input-wrapper">
                <label htmlFor="nonMap" className="label">
                  NonMap
                </label>
                <input
                  type="number"
                  id="nonMap"
                  name="nonMap"
                  min="1"
                  value={formData?.nonMapPercentage}
                  onChange={handleChange}
                />
                <div
                  style={{
                    position: "absolute", // Position buttons absolutely
                    right: "8px", // Align to the right side of the main container
                    top: "50%", // Vertically center
                    transform: "translateY(-50%)", // Adjust for exact vertical centering
                    display: "flex",
                    flexDirection: "column", // Stack buttons vertically
                    gap: "3px",
                  }}
                >
                  <button
                    onClick={() => handleIncrement("nonMapPercentage")}
                    style={{
                      backgroundColor: "#e5e5e6",
                      borderRadius: "6px",
                      border: "none", // No border
                      padding: "0", // No padding
                      cursor: "pointer", // Pointer cursor on hover
                      height: "20px", // Fixed height
                      width: "20px", // Fixed width
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#666", // Dark grey color for the icon
                      outline: "none", // Remove outline on focus
                      transition: "background-color 0.2s", // Smooth transition for hover effect
                    }}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </button>

                  <button
                    onClick={() => handleDecrement("nonMapPercentage")}
                    style={{
                      backgroundColor: "#e5e5e6",
                      borderRadius: "6px",
                      border: "none",
                      padding: "0",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#666",
                      outline: "none",
                      transition: "background-color 0.2s",
                    }}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </button>
                </div>
              </div>
            </Col>
            <Col
              xs={1}
              style={{
                borderLeft: "0.5px solid #e1e5e8",
                borderRight: "0.5px solid #e1e5e8",
                borderBottom: "0.5px solid #e1e5e8",
                padding: "0.5rem  0.2rem",
                height: "70px",
                display: "flex",
                alignItems: "center",
              }}
            ></Col>
            <Col
              xs={1}
              style={{
                borderLeft: "0.5px solid #e1e5e8",
                borderRight: "0.5px solid #e1e5e8",
                borderBottom: "0.5px solid #e1e5e8",
                padding: "0.5rem  0.2rem",
                height: "70px",
                display: "flex",
                alignItems: "center",
              }}
            ></Col>
          </Row>
        </div>
      </Row>

      {/* UpdateButton - Retained from original code, commented out for standalone preview */}
      <Row className="mt-4">
        <Col className="d-flex justify-content-center">
          {/* Uncomment the following lines if you have the UpdateButton component */}

          <UpdateButton
            position="fixed" // Adjust position as needed based on its internal implementation
            brand={selectedItem?.fullName}
            loading={loading}
            onClick={() => handleUpdate(selectedItem?._id)}
          />
        </Col>
      </Row>

      <style jsx>{`
        .input-wrapper {
          position: relative;
          width: 100%;
          padding: 0px 5px;
        }
        input {
          border: 1px solid #000;
          border-radius: 6px;
          width: 100%;
          padding: 15px;
          font-size: 16px;
          margin: 0;
          -moz-appearance: textfield;
          -webkit-appearance: none;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
        .label {
          position: absolute;
          top: -0.8ex;
          left: 0.7em;
          background-color: #fafafa;
          color: #333;
          // padding: 0 5px;
          line-height: 0.9;
          font-size: 16px;
          z-index: 1;
        }
        ::placeholder {
          color: #7d7d7d;
          opacity: 1; /* Firefox */
        }
        ::-ms-input-placeholder {
          /* Edge 12-18 */
          color: #7d7d7d;
        }
      `}</style>
    </Container>
  );
};

export default ManageGlobalMargin;
